import _cloneDeep from "lodash/cloneDeep";
import fonts from "@/scss/_fonts.scss";

const defaultAxis = {
    splitLine: {
        show: true
    },

    axisLabel: {
        color: "#999",
        axisLine: {
            show: false
        }
    }
};

export const defaultLineStyle = {
    type: "line",
    smooth: false,
    lineStyle: {
        width: 3
    }
};

export const defaultBarStyle = {
  type: "bar",
  smooth: false
};

export const defaultOptions = {
    tooltip: {
        trigger: "axis",
        confine: true,
        renderMode: "richText",
        axisPointer: {
            type: "none",
            snap: true,
            label: {
                backgroundColor: "#6A7985"
            }
        }
    },

    grid: {
        top: 90,
        left: 20,
        right: 40,
        bottom: 20,
        containLabel: true
    },

    // dataZoom: [
    //     {
    //         type: "slider",
    //         xAxisIndex: [0],
    //         left: 100,
    //         right: 100
    //     },
    //     {
    //         type: "slider",
    //         yAxisIndex: [0],
    //         showDetail: false,
    //         right: 20
    //     }
    // ],

    textStyle: {
        fontFamily: fonts.mainFont
    },

    legend: {
        top: 40,
        left: 0,
        right: 0,
        type: "scroll",
        icon: "circle"
    },

    xAxis: _cloneDeep(defaultAxis),

    yAxis: _cloneDeep(defaultAxis)
};
